import { Environment } from '@environment';

export default {
  local: {
    apiUrl: 'https://localhost:7296/api',
    region: 'UK',
    giveFeedbackUrl:
      'https://docs.google.com/forms/d/e/1FAIpQLSekOERw6QLHmJthG2tQ2vTINB74z3f13BWyJgb2vH0davmOnA/viewform?usp=sf_link',
    reportIssueUrl: 'https://forms.office.com/r/5bZmHUtySX',
  },
  dev: {
    apiUrl: 'https://pwc-deals-dev-api.devbstaging.com/api',
    region: 'UK',
  },
  e2e: {
    apiUrl: 'https://pwc-deals-e2e-api.azurewebsites.net/api',
    region: 'UK',
  },
  uat: {
    apiUrl: 'https://pwc-deals-uat-api.devbstaging.com/api',
    region: 'UK',
  },
  dem: {
    apiUrl: 'https://pwc-deals-dem-api.devbstaging.com/api',
    region: 'UK',
  },
} as Environments;

export interface EnvironmentConfig {
  apiUrl: string;
  region: string;
  giveFeedbackUrl?: string;
  reportIssueUrl?: string;
  redirectUrl?: string;
}

type Environments = {
  [key in Environment]: EnvironmentConfig;
};
